import PropTypes from 'prop-types';
import React from 'react';

import RichTextConverter from '../RichText/RichTextConverter';
import * as styles from './Carousel.module.css';
import ProgressBar from './ProgressBar';

/*eslint-disable */
class CarouselListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      isMobile: false,
    };
    this.heightRef = React.createRef();
    this.descriptionHeight = 0;
  }

  componentDidMount() {
    this.descriptionHeight = this.heightRef?.current?.offsetHeight || 0;
    this.setState({ width: window.innerWidth, isMobile: window.innerWidth < 768 });
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = async () => {
    await this.setState({ width: window.innerWidth, isMobile: window.innerWidth < 768 });
    this.descriptionHeight = this.heightRef.current.offsetHeight + 16;
  };

  render() {
    const {
      contentful_id,
      number,
      heading,
      description,
      showTimerProgress,
      isSelected,
      rotateRate,
      begin,
    } = this.props;

    const { isMobile } = this.state;

    return (
      <li className={styles.item} onClick={() => this.props.onSelect(contentful_id)}>
        <span className={styles.number} style={!isMobile ? { color: isSelected ? '#000' : '#888' } : {}}>
          {number}
        </span>
        <h7 className={styles.heading} style={!isMobile ? { color: isSelected ? '#000' : '#888' } : {}}>
          {heading}
        </h7>
        <div className={[isSelected ? styles.showProgress : styles.hide].join(' ')}>
          {showTimerProgress && <ProgressBar duration={rotateRate} starting={begin} />}
        </div>
        <div
          style={{ height: isSelected || isMobile ? this.descriptionHeight : 0 }}
          className={[styles.description, isSelected ? styles.open : styles.collapse].join(' ')}
        >
          {description && (
            <div ref={this.heightRef}>
              <RichTextConverter copy={description} />
            </div>
          )}
        </div>
      </li>
    );
  }
}

CarouselListItem.propTypes = {
  contentful_id: PropTypes.string,
  number: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.object,
  showTimerProgress: PropTypes.bool,
  isSelected: PropTypes.bool,
  rotateRate: PropTypes.number,
  begin: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default CarouselListItem;
